export enum ValidationSeverity {
    ERROR = 'ERROR',
    INFO = 'INFO'
}
